(function(){
'use strict';
if(window.mrakContactTracking)return;
var queue=[],loadingPrivacy=false,started=false,tagReady=false;
var measurementId='G-6037ZG2QG5',layerName='mrakContactDataLayer';
var names=['mrak_contact_open','mrak_contact_topic_select','mrak_contact_form_start','mrak_contact_submit','mrak_contact_form_submit','mrak_contact_success'];
function status(value){var root=document.getElementById('mrak-contact-panel');if(root)root.dataset.mrcTracking=value;}
function privacy(){return window.Shopify&&window.Shopify.customerPrivacy;}
function allowed(){try{return !!(privacy()&&privacy().analyticsProcessingAllowed());}catch(e){return false;}}
function command(){window[layerName].push(arguments);}
function consent(granted){command('consent','update',{analytics_storage:granted?'granted':'denied',ad_storage:'denied',ad_user_data:'denied',ad_personalization:'denied'});}
function flush(){
 if(!allowed()){if(started)consent(false);queue=[];status('consent-not-granted');return;}
 if(!started){
  started=true;window[layerName]=window[layerName]||[];
  command('consent','default',{analytics_storage:'granted',ad_storage:'denied',ad_user_data:'denied',ad_personalization:'denied'});
  command('js',new Date());command('config',measurementId,{send_page_view:false,allow_google_signals:false,allow_ad_personalization_signals:false,groups:'mrak_contact_only'});
  var script=document.createElement('script');script.id='mrak-contact-google-tag';script.async=true;script.src='https://www.googletagmanager.com/gtag/js?id='+measurementId+'&l='+layerName;
  script.onload=function(){tagReady=true;status('tag-loaded');flush();};script.onerror=function(){status('tag-load-error');};document.head.appendChild(script);status('tag-loading');
 }
 if(!tagReady)return;
 consent(true);
 while(queue.length){var event=queue.shift();var payload=Object.assign({},event.payload,{send_to:measurementId,transport_type:'beacon',page_location:location.origin+event.payload.source_page_path,page_referrer:location.origin});
  payload.event_callback=(function(name){return function(){var root=document.getElementById('mrak-contact-panel');if(root){root.dataset.mrcLastEvent=name;root.dataset.mrcTracking='tag-processed';}};})(event.name);
  command('event',event.name,payload);
 }
}
function prepare(){
 if(privacy()){flush();return;}
 if(loadingPrivacy)return;
 if(window.Shopify&&typeof window.Shopify.loadFeatures==='function'){
  loadingPrivacy=true;window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],function(error){loadingPrivacy=false;if(error){status('privacy-api-error');return;}flush();});
 }else status('privacy-api-unavailable');
}
window.mrakContactTracking={track:function(name,payload){
 if(names.indexOf(name)<0)return;
 var clean={};['source_page_path','contact_language','contact_topic','device_type','product_id','variant_id'].forEach(function(k){var v=payload&&payload[k];if(typeof v!=='string'||!v)return;if((k==='product_id'||k==='variant_id')&&!/^\d+$/.test(v))return;if(k==='source_page_path'&&(v[0]!=='/'||/[?#]/.test(v)))return;clean[k]=v;});
 if(!clean.source_page_path)return;
 var emittedName=name==='mrak_contact_submit'?'mrak_contact_form_submit':name;
 if(queue.length<30)queue.push({name:emittedName,payload:clean});prepare();
}};
document.addEventListener('visitorConsentCollected',function(){if(started)consent(allowed());flush();});
})();
